<script setup lang="ts">
import CoinsTotal from '@/components/CoinsTotal.vue'
import { computed, onMounted, ref, watch } from 'vue'
import { useAnimateCoins } from '@/composables/game/flying-coins'
import { formatUnshortenedNumber } from '@/helpers/utils'
import GoldCoinIcon from '@/assets/images/icons/gold-coin-icon-s3.webp'

const props = defineProps<{
  coins: number
  duration?: number
}>()

const coinsWrapper = ref<HTMLElement | null>()

const { animateCoins } = useAnimateCoins()
// const digitWidth = 24
// const commaWidth = 10
// const coinsNumLength = computed(() => props.coins.toString().length)
// const currentWidth = computed(() => {
//   const numCommas = Math.floor((coinsNumLength.value - 1) / 3) // One less than the number of groups of three digits
//   return coinsNumLength.value * digitWidth + numCommas * commaWidth
// })
// const marginLeftClass = computed(() => {
//   if (coinsNumLength.value <= 2) {
//     return 'ml-1'
//   }
//   if (coinsNumLength.value <= 4) {
//     return 'ml-1.5'
//   }
//   if (coinsNumLength.value <= 6) {
//     return 'ml-2'
//   }
//   return 'ml-3'
// })

const animate = ref(true)

const fontSizeClass = computed(() => {
  if (props.coins >= 1e24) {
    return 'text-[18px]'
  }
  if (props.coins >= 1e21) {
    return 'text-[20px]'
  }
  if (props.coins >= 1e18) {
    return 'text-[22px]'
  }
  if (props.coins >= 1e15) {
    return 'text-[24px]'
  }
  if (props.coins >= 1e12) {
    return 'text-[28px]'
  }
  return 'text-[28px]'
})

const coinIconHeight = computed(() => {
  if (props.coins >= 1e24) {
    return 18
  }
  if (props.coins >= 1e21) {
    return 20
  }
  if (props.coins >= 1e18) {
    return 22
  }
  if (props.coins >= 1e15) {
    return 24
  }
  if (props.coins >= 1e12) {
    return 28
  }
  return 20
})

onMounted(() => {
  setTimeout(() => animate.value = false, 500)
})

watch(() => props.coins, () => {
  if (!coinsWrapper.value) return
  coinsWrapper.value.classList.add('pulse')
  setTimeout(() => {
    if (!coinsWrapper.value) return
    coinsWrapper.value.classList.remove('pulse')
  }, 150)
})
</script>

<template>
  <div
    ref="coinsWrapper"
    id="coins-wrapper"
    class="h-10 inline-flex max-w-fit mx-auto"
    :class="{'scale-in': animate}"
  >
    <div
      class="flex items-center gap-x-2 transition-[margin] duration-300"
    >
      <img
        class="w-auto object-cover"
        :style="{height: coinIconHeight + 'px'}"
        alt="Coin Icon"
        :src="GoldCoinIcon"
      >
      <div
        class="leading-10 font-semibold font-pilat flex items-center justify-center"
        :class="[fontSizeClass]"
        style="font-variant-numeric: lining-nums tabular-nums slashed-zero;"
      >
        <span
          v-if="!animateCoins"
          class="w-full"
        >
          {{ formatUnshortenedNumber(coins) }}
        </span>
        <CoinsTotal
          v-else
          class="w-full"
          :coins="coins"
          :duration="duration"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.pulse {
  animation: pulse 0.15s ease-in-out;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
</style>
